import type { CustomRouteSearchState } from 'src/app/pages/search/shared/types';

export const windowTitle = (routeState: CustomRouteSearchState) => {
	if (!routeState.q) {
		return 'Change.org - Results page';
	}

	return `Change.org - Results for: ${routeState.q}`;
};
